<template>
    <div class="container" :class="{ containerRJI: nomeEmpresa == 'RJI' || nomeEmpresa == 'ACTUAL' }">
        <div class="left-side">
            <div class="form-container">
                <h2>Esqueci minha senha</h2>
                <img src="@/assets/progressoCadastro.png" alt="Logo" class="logoProgresso"
                    v-if="nomeEmpresa != 'ACTUAL' && nomeEmpresa != 'RJI'">
                <img src="@/assets/progressoCadastro2_rji.png" alt="Logo" class="logoProgresso"
                    v-if="nomeEmpresa == 'ACTUAL' && nomeEmpresa != 'RJI'">
                <form>
                    <label for="email">E-mail*</label>
                    <input type="email" v-model="cadastro.email" id="email" placeholder="Insira seu e-mail">
                    <button type="button" class="submit-button"
                        :class="{ 'disabled': $v && $v.cadastro && $v.cadastro.$invalid }"
                        @click="recuperarSenha()">Recuperar senha</button>
                </form>
                <div class="footer">
                    <p>Já possui uma conta? <a :href="configuracaoURLEntrar">Entrar</a></p>
                </div>
            </div>
        </div>
        <div class="right-side"
            :class="{ rightSideGenial: nomeEmpresa == 'GENIAL', rightSideActual: nomeEmpresa == 'ACTUAL' }">
            <!-- A imagem pode ser definida via CSS para responsividade -->
        </div>
    </div>
</template>

<script>
import { required, email, minLength } from '@vuelidate/validators';
import validateCpf from '@/utils/validateCpf';
import validateCnpj from '@/utils/validateCnpj';
import { mapGetters, mapActions } from 'vuex';
import api from '@/api/axios';

export default {
    name: 'RecuperarSenha',
    data() {
        return {
            nomeEmpresa: '',
            cadastro: {
                email: null
            },
            permitirAvancar: false,
            configuracaoURLEntrar: '/Login'
        };
    },
    computed: {
        ...mapGetters({
            account: 'GET_CREATE_ACCOUNT',
            configuracoes: 'GET_CONFIGURACAO',
        }),
    },
    validations() {
        const validations = {
            email: { required, email },
        };
        if (this.cadastro.selectedTipoCliente === 'PF') {
            validations.CPF = {
                required,
                validateCpf
            };
            validations.nomeCompleto = {
                required,
                minLength: minLength(5) // Supondo que o nome completo deve ter pelo menos 5 caracteres
            };
        } else if (this.cadastro.selectedTipoCliente === 'PJ') {
            validations.CNPJ = {
                required,
                validateCnpj
            };
            validations.razaoSocial = {
                required,
                minLength: minLength(5) // Supondo que o nome completo deve ter pelo menos 5 caracteres
            };
        }
        return { cadastro: validations };
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        if (this.account != null) {
            this.cadastro = this.account;
        }
    },
    created() {
        this.fetchConfiguracao('Redirecionamento do botão entrar Onboarding externo');
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACAO'
        }),
        limparCadastro() {
            this.cadastro.email = null;
        },
        validarAvancar() {
            var nomeCampo = '';
            if (this.cadastro.email == '' || this.cadastro.email == null) {
                nomeCampo = 'E-mail';
            }
            if (nomeCampo != '') {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Necessário preencher o campo ` + nomeCampo,
                });
                return false;
            }
            return true;
        },
        async recuperarSenha() {
            if (this.validarAvancar()) {
                var encodedCredentials = btoa('sat@sat:sat23!');
                var objConcluir = { Email: this.cadastro.email, ClienteGuid: '' };
                await api.post('/register/restaurar-senha', objConcluir, {
                    headers: {
                        'Authorization': `Basic ${encodedCredentials}`
                    },
                })
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'E-mail enviado!',
                                text: `Acesse o e-mail para visualizar sua senha de acesso.`,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$swal({
                            icon: 'error',
                            title: 'Conta não localizada',
                            text: 'Nenhuma conta com endereço de e-mail informado foi localizado',
                        });
                    });
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Conta não localizada',
                    text: 'Nenhuma conta com endereço de e-mail informado foi localizado',
                });
            }
        }
    },
    watch: {
        consultarPermissaoAvancar() {
            this.permitirAvancar = false;
            if (this.cadastro.selectedTipoCliente == 'PF') {
                // Para Pessoa Física, nome completo e CPF são obrigatórios
                if (this.cadastro.nomeCompleto && this.cadastro.nomeCompleto.length > 5 && this.validarCPF(this.cadastro.CPF)) {
                    this.permitirAvancar = true;
                }
            } else if (this.cadastro.selectedTipoCliente == 'PJ' || this.cadastro.selectedTipoCliente == 'FU') {
                // Para Pessoa Jurídica ou Funcionário, razão social e CNPJ são obrigatórios
                if (this.cadastro.razaoSocial && this.cadastro.CNPJ && this.validarCNPJ(this.cadastro.CNPJ)) {
                    this.permitirAvancar = true;
                }
            }
        },
        configuracoes(newVal) {
            if (newVal && newVal.Valor) {
                this.configuracaoURLEntrar = newVal.Valor;
            } else {
                console.error('Configurações não são válidas:', newVal);
                this.configuracaoURLEntrar = [];
            }
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    min-height: 100vh;
    /* Viewport height */
    overflow: hidden;
    /* Isso pode ajudar a impedir o scroll indesejado */
}

.containerRJI {
    background-color: rgba(15, 37, 71, 1) !important;

    color: #FFF;
}


.containerRJI h2 {
    color: #FFF !important;
}

.containerRJI p {
    color: #FFF !important;
}

.containerRJI label {
    color: #FFF !important;
}

.containerRJI a {
    color: #FFF !important;
    font-weight: 800;
}



.logoProgresso {
    width: 380px;
    height: 10px;
}


h2 {
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    /* Semibold */
    font-size: 30px;
    line-height: 38px;
    color: #101828;
    /* Gray/900 */
}

.right-side {
    width: 50%;
    background: url('@/assets/fundoCadastro.png') no-repeat center center;
    background-size: cover;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideGenial {
    width: 50%;
    background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('@/assets/fundoGenialCadastro.png') !important;

    background-size: cover;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideActual {
    width: 50%;
    background: url('@/assets/fundo_actual.png') !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

/* Aplicando estilos de fonte */
button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}


input,
select {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    /* Ajuste para a linha de altura */
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Arredondamento dos inputs */
    box-sizing: border-box;
    /* Garante que o padding não adicione largura extra */
    width: 100%;
    /* Para garantir que os inputs ocupem toda a largura do container */

}

/* Estilos para os rótulos (labels) do formulário */
form label {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 500;
    /* Peso médio da fonte */
    font-size: 14px;
    /* Tamanho da fonte */
    line-height: 20px;
    /* Altura da linha */
    color: #344054;
    /* Cor do texto em cinza escuro */
}

.footer {
    text-align: center;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    /* Este é um cinza genérico, ajuste conforme necessário */
    font-size: 16px;
    /* Exemplo de tamanho de fonte, ajuste conforme necessário */
    line-height: 24px;
    /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
    font-weight: 600;
    /* Para 'Cadastre-se', que parece ser mais destacado */
    color: #101828;
    /* Este é o azul padrão de links, ajuste conforme necessário */
    text-decoration: none;
    /* Para sublinhar o link */
}


/* Estilos para o formulário */
form {
    display: flex;
    flex-direction: column;
}

/* Estilos para os inputs */
input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.left-side {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
}

.left-side {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
}

.form-container {
    max-width: 400px;
    margin: 0 auto;
}

input,
select {
    width: 100%;
    padding: 0.5rem;
    margin: 0.5rem 0;
    border: 1px solid #ccc;
}

.submit-button {
    width: 100%;
    padding: 0.5rem;
    margin-top: 1rem;
    color: white;
    border: none;
    cursor: pointer;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
}




/* Responsividade */
@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }

    .left-side,
    .right-side {
        width: 100%;
    }

    .right-side {
        background-size: contain;
        /* ou você pode tentar 100% 100% para forçar a cobertura completa */
        height: auto;
        /* ajuste a altura para manter a proporção da imagem */
    }

}
</style>
